import { MessageSquare, User } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import {
  defaultMessageSenderRoleLabel,
  messageSenderRoleKey,
  type ResolvedMessageSender,
} from '@/utils/messageSender';

interface MessageSenderHeadingProps {
  sender: ResolvedMessageSender;
  timestamp: string;
}

export function MessageSenderHeading({ sender, timestamp }: MessageSenderHeadingProps) {
  const { t } = useTranslation();
  const isPatient = sender.role === 'patient';
  const roleLabel = t(messageSenderRoleKey(sender.role), defaultMessageSenderRoleLabel(sender.role));

  return (
    <div className="flex items-center gap-2">
      <div
        className={`flex h-8 w-8 items-center justify-center rounded-full ${
          isPatient ? 'bg-ds-sunk text-ds-teal' : 'bg-ds-teal-tint text-ds-teal'
        }`}
      >
        {isPatient ? <User className="h-4 w-4" /> : <MessageSquare className="h-4 w-4" />}
      </div>
      <div>
        <p className="text-sm font-semibold text-ds-text">{sender.name}</p>
        <p className="text-xs text-ds-muted">
          {roleLabel} · {timestamp}
        </p>
      </div>
    </div>
  );
}
